import { render } from "./SectionStepTwo.vue?vue&type=template&id=4487d4c5"
import script from "./SectionStepTwo.vue?vue&type=script&lang=js"
export * from "./SectionStepTwo.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__